import { render, staticRenderFns } from "./BasicInformationAboutSubjectText.vue?vue&type=template&id=64110a4c&scoped=true&"
import script from "./BasicInformationAboutSubjectText.vue?vue&type=script&lang=js&"
export * from "./BasicInformationAboutSubjectText.vue?vue&type=script&lang=js&"
import style0 from "./BasicInformationAboutSubjectText.vue?vue&type=style&index=0&id=64110a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64110a4c",
  null
  
)

export default component.exports